/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_037: Question = {
  id: 'pres-037-habitats-sad-pmad',
  oldId: '51',
  title: 'Intégration des habitats fauniques et floristiques d’intérêt dans le schéma d’aménagement et de développement (SAD) ou plan métropolitain d’aménagement et de développement (PMAD)',
  number: '3.21',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 3,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_037_v2: Question = question_pres_037;
export const question_pres_037_v3: Question = question_pres_037;
